import { ColumnModel } from './column.model';

export interface GroupedColumnsModel {
	sampleColumns: ColumnModel[];
	standardColumns: ColumnModel[];
}
